<template>
  <v-flex
    xs12
    md4
  >
    <v-card>
      <v-avatar
        class="mx-auto avatar"
        size="120"
      >
        <img :src="profile.avatar ? profile.avatar : placeholder">
      </v-avatar>
      <v-card-text class="text-center content">
        <h1 class="font-weight-bold">{{username}}</h1>
        <h5 class="primary--text mb-3">{{profile.title}}</h5>
        <p>{{profile.bio}}</p>

        <a
          :href="profile.website"
          target="_blank"
          v-if="profile.website"
        >
          <v-btn
            class="ma-2"
            fab
            small
            color="primary"
          >
            <v-icon dark>mdi-earth</v-icon>
          </v-btn>
        </a>

        <a
          :href="profile.linkedin"
          target="_blank"
          v-if="profile.linkedin"
        >
          <v-btn
            class="ma-2"
            fab
            small
            color="primary"
          >
            <v-icon dark>mdi-linkedin</v-icon>
          </v-btn>
        </a>

        <a
          :href="profile.facebook"
          target="_blank"
          v-if="profile.facebook"
        >
          <v-btn
            class="ma-2"
            fab
            small
            color="primary"
          >
            <v-icon dark>mdi-facebook</v-icon>
          </v-btn>
        </a>

        <a
          :href="profile.instagram"
          target="_blank"
          v-if="profile.instagram"
        >
          <v-btn
            class="ma-2"
            fab
            small
            color="primary"
          >
            <v-icon dark>mdi-instagram</v-icon>
          </v-btn>
        </a>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ProfilePreview',
    props: {
      profile: { type: Object }
    },
    data() {
      return {
        placeholder: `${process.env.VUE_APP_API}/img/system/avatar-placeholder.png`
      }
    },
    computed: {
      ...mapGetters([
        'username'
      ])
    },
  }
</script>

<style scoped>
  .avatar {
    position: absolute;
    margin-top: -60px;
    left: calc(50% - 60px);
  }

  .avatar > img {
    border-radius: 50%;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    background-color: #a4a4a5;
  }

  .content {
    padding-top: 80px;
    margin-top: 60px;
  }

  a {
    text-decoration: none;
  }
</style>